/* =========================================================
   SIŁA PO ROZSTANIU — theme.js
   Waniliowy JS, bez zależności. ~4 KB.
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------------------------------------------------------
     1. HEADER — cień po scrollu
     ------------------------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -------------------------------------------------------
     2. SELEKTOR PAKIETU — wspólny stan dla wszystkich instancji
     ------------------------------------------------------- */
  var State = {
    value: null,
    variantId: null,
    price: '',
    compare: '',
    label: '',
    available: true
  };

  // Warianty obu opcji (sam ebook / pakiet), niezależnie od tego,
  // która jest aktualnie zaznaczona — potrzebne do oferty dopłaty.
  var Variants = {};

  function readOption(input) {
    return {
      value: input.value,
      variantId: input.getAttribute('data-variant-id') || null,
      price: input.getAttribute('data-price') || '',
      compare: input.getAttribute('data-compare') || '',
      label: input.getAttribute('data-label') || '',
      available: input.getAttribute('data-available') !== 'false'
    };
  }

  function paint() {
    // wszystkie wyświetlacze ceny (hero, sekcje CTA)
    document.querySelectorAll('[data-buy-price]').forEach(function (el) {
      el.textContent = State.price;
    });
    document.querySelectorAll('[data-buy-compare]').forEach(function (el) {
      el.textContent = State.compare;
      el.hidden = !State.compare;
    });
    document.querySelectorAll('[data-buy-label]').forEach(function (el) {
      el.textContent = State.label;
    });
    // wszystkie przyciski kupna
    document.querySelectorAll('[data-buy]').forEach(function (btn) {
      if (State.variantId) {
        btn.setAttribute('data-variant-id', State.variantId);
        btn.disabled = false;
      }
      btn.setAttribute('data-buy-value', State.value || '');
    });
    // podświetlenie kart
    document.querySelectorAll('[data-bundle-option]').forEach(function (lbl) {
      var input = lbl.querySelector('input');
      lbl.classList.toggle('is-selected', !!(input && input.checked));
    });
  }

  function select(value, source) {
    // zsynchronizuj WSZYSTKIE grupy radio (selektor może być na stronie 3x)
    document.querySelectorAll('[data-bundle-option] input').forEach(function (input) {
      input.checked = input.value === value;
    });
    if (source) {
      State.value = value;
      State.variantId = source.variantId;
      State.price = source.price;
      State.compare = source.compare;
      State.label = source.label;
      State.available = source.available;
    }
    paint();
  }

  var bundleInputs = document.querySelectorAll('[data-bundle-option] input');
  if (bundleInputs.length) {
    // zapamiętaj dane obu wariantów (do oferty dopłaty), zanim cokolwiek się zmieni
    bundleInputs.forEach(function (input) {
      if (!Variants[input.value]) {
        Variants[input.value] = readOption(input);
      }
    });

    bundleInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) select(input.value, readOption(input));
      });
    });
    // stan początkowy = pierwszy zaznaczony (pakiet ustawiony w Liquid)
    var initial = document.querySelector('[data-bundle-option] input:checked') || bundleInputs[0];
    if (initial) {
      initial.checked = true;
      select(initial.value, readOption(initial));
    }
  }

  /* -------------------------------------------------------
     3. DODANIE DO KOSZYKA → PROSTO DO CHECKOUTU
     ------------------------------------------------------- */
  function goToCheckout(variantId, btn) {
    // Tryb demo (brak podpiętego produktu) — nie udajemy zakupu.
    if (!variantId || variantId === 'demo') {
      var target = btn.getAttribute('data-fallback-href');
      if (target) window.location.href = target;
      return;
    }

    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');

    // czyścimy koszyk — produkt cyfrowy, zawsze dokładnie jedna pozycja
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/clear.js' : '/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Błąd'); });
        return res.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.setAttribute('aria-busy', 'false');
        var box = document.querySelector('[data-buy-error]');
        if (box) {
          box.textContent = 'Nie udało się przejść do płatności: ' + err.message + ' Odśwież stronę albo napisz do nas.';
          box.hidden = false;
        } else {
          window.location.href = '/cart';
        }
      });
  }

  function buy(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var buyValue = btn.getAttribute('data-buy-value') || State.value;
    var bundleVariant = Variants.bundle;

    // Upsell: pokazujemy ofertę dopłaty TYLKO gdy klient wybrał "sam ebook"
    // i mamy realnie podpięty wariant pakietu (nie demo).
    if (buyValue === 'single') {
      window.location.href = '/pages/upsell';
      return;
    }

    goToCheckout(variantId, btn);
  }

  document.querySelectorAll('[data-buy]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      buy(btn);
    });
  });

  /* -------------------------------------------------------
     3b. MODAL OFERTY JEDNORAZOWEJ (dopłata do pakietu)
     Pojawia się tylko po kliknięciu "Kup" przy wybranym
     wariancie "Sam ebook". Bez liczników / fałszywej presji.
     ------------------------------------------------------- */
  var upsellEl = null;
  var upsellLastFocus = null;

  function buildUpsellModal() {
    if (upsellEl) return upsellEl;

    var style = document.createElement('style');
    style.id = 'upsell-modal-styles';
    style.textContent =
    '.upsell-overlay{position:fixed;inset:0;z-index:300;display:flex;align-items:flex-end;justify-content:center;' +
    'background:rgba(36,30,27,.55);backdrop-filter:blur(2px);padding:0;opacity:0;pointer-events:none;' +
    'transition:opacity .18s ease;}' +
    '.upsell-overlay.is-open{opacity:1;pointer-events:auto;}' +
    '@media (min-width:640px){.upsell-overlay{align-items:center;padding:var(--s4,16px);}}' +
    '.upsell-modal{width:100%;max-width:460px;background:var(--tlo-glowne,#FDF9F5);' +
    'border-radius:var(--r-lg,28px) var(--r-lg,28px) 0 0;' +
    'padding:0;' +
    'box-shadow:0 -8px 40px rgba(36,30,27,.25);' +
    'transform:translateY(24px);transition:transform .2s ease;max-height:92vh;overflow-y:auto;}' +
    '.upsell-overlay.is-open .upsell-modal{transform:translateY(0);}' +
    '@media (min-width:640px){.upsell-modal{border-radius:var(--r-lg,28px);box-shadow:0 20px 60px rgba(36,30,27,.3);}}' +
    '.upsell-modal__banner{background:var(--akcent-btn,#A9543A);color:#fff;font-weight:700;font-size:.8125rem;' +
    'letter-spacing:.02em;text-align:center;padding:13px 46px 13px 16px;line-height:1.45;' +
    'border-radius:var(--r-lg,28px) var(--r-lg,28px) 0 0;}' +
    '.upsell-modal__content{padding:22px var(--gutter,20px) calc(24px + env(safe-area-inset-bottom,0px));}' +
    '.upsell-modal__subtitle{font-size:.875rem;color:var(--tekst-mieki,#6B5F58);margin:0 0 18px;line-height:1.5;}' +
    '.upsell-modal__congrats{border:1.5px solid rgba(138,154,123,.45);background:rgba(138,154,123,.09);' +
    'border-radius:var(--r-md,20px);padding:14px 16px;font-size:.9375rem;line-height:1.55;color:var(--tekst,#241E1B);margin:0 0 18px;}' +
    '.upsell-modal__divider{display:flex;align-items:center;gap:10px;margin:0 0 18px;' +
    'font-size:.75rem;font-weight:700;letter-spacing:.03em;text-transform:uppercase;color:var(--tekst-mieki,#6B5F58);text-align:center;}' +
    '.upsell-modal__divider::before,.upsell-modal__divider::after{content:"";flex:1;height:1px;background:var(--linia,rgba(36,30,27,.10));}' +
    '.upsell-modal__title{font-family:var(--font-display,inherit);font-weight:800;font-size:1.375rem;' +
    'line-height:1.25;letter-spacing:-.01em;color:var(--tekst,#241E1B);margin:0 0 10px;}' +
    '.upsell-modal__body{font-size:1rem;line-height:1.6;color:var(--tekst-mieki,#6B5F58);margin:0 0 22px;}' +
    '.upsell-modal__body strong{color:var(--tekst,#241E1B);}' +
    '.upsell-modal__actions{display:grid;gap:10px;}' +
    '.upsell-modal__decline{display:inline-flex;align-items:center;justify-content:center;min-height:48px;' +
    'padding:0 20px;border-radius:999px;background:transparent;border:1.5px solid rgba(36,30,27,.16);' +
    'color:var(--tekst-mieki,#6B5F58);font-size:.9375rem;font-weight:600;cursor:pointer;' +
    '-webkit-tap-highlight-color:transparent;transition:background .15s ease;}' +
    '.upsell-modal__decline:hover{background:rgba(36,30,27,.05);}' +
    '.upsell-modal__close{position:absolute;top:11px;right:11px;width:32px;height:32px;border:0;' +
    'background:rgba(255,255,255,.25);border-radius:999px;display:grid;place-items:center;cursor:pointer;' +
    'color:#fff;-webkit-tap-highlight-color:transparent;z-index:2;}' +
    '.upsell-modal{position:relative;}';
  document.head.appendChild(style);

    var overlay = document.createElement('div');
    overlay.className = 'upsell-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
    '<div class="upsell-modal" role="dialog" aria-modal="true" aria-labelledby="upsell-modal-title">' +
    '<div class="upsell-modal__banner">\u26A0\uFE0F CHWILA \u2014 TWOJE ZAM\u00D3WIENIE NIE JEST JESZCZE KOMPLETNE!</div>' +
    '<button type="button" class="upsell-modal__close" data-upsell-close aria-label="Zamknij">' +
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
    '</svg></button>' +
    '<div class="upsell-modal__content">' +
    '<h2 class="upsell-modal__title" id="upsell-modal-title">Zanim sfinalizujesz zakup \u2014 mamy dla Ciebie co\u015B wyj\u0105tkowego.</h2>' +
    '<p class="upsell-modal__subtitle">Ta oferta pojawia si\u0119 tu tylko raz \u2014 specjalnie dla Ciebie.</p>' +
    '<div class="upsell-modal__congrats">Po pierwsze \u2013 gratulujemy tej decyzji! Dzi\u0119ki ebookowi \u201E10 krok\u00F3w do wyleczenia si\u0119 po toksycznej relacji\u201D otrzymujesz konkretny plan dzia\u0142ania. Nie ka\u017Cda kobieta ma odwag\u0119, by zacz\u0105\u0107 \u2013 a Ty w\u0142a\u015Bnie to zrobi\u0142a\u015B.</div>' +
    '<div class="upsell-modal__divider">Zanim jednak zrealizujesz zam\u00F3wienie, mamy dla Ciebie jeszcze jedn\u0105 rzecz...</div>' +
    '<p class="upsell-modal__body">Za jedyne <strong>20\u00A0z\u0142</strong> wi\u0119cej dostajesz te\u017C <strong>\u201E30 dni pewno\u015Bci siebie po toksycznej relacji\u201D</strong> \u2014 codzienny plan na kolejny krok.</p>' +
    '<div class="upsell-modal__actions">' +
    '<button type="button" class="btn btn--full" data-upsell-accept>Tak, dodaj drugi ebook (+20\u00A0z\u0142)</button>' +
    '<button type="button" class="upsell-modal__decline" data-upsell-decline>Nie, dzi\u0119kuj\u0119, chc\u0119 tylko ten ebook</button>' +
    '</div>' +
    '</div>' +
    '</div>';

  document.body.appendChild(overlay);
    upsellEl = overlay;
    return overlay;
  }

  function openUpsellModal(handlers) {
    var overlay = buildUpsellModal();
    upsellLastFocus = document.activeElement;

    var accept = overlay.querySelector('[data-upsell-accept]');
    var decline = overlay.querySelector('[data-upsell-decline]');
    var closeBtn = overlay.querySelector('[data-upsell-close]');

    function onAccept() { handlers.onAccept && handlers.onAccept(); }
    function onDecline() { handlers.onDecline && handlers.onDecline(); }
    function onKeydown(e) {
      if (e.key === 'Escape') onDecline();
    }
    function onOverlayClick(e) {
      if (e.target === overlay) onDecline();
    }

    accept.addEventListener('click', onAccept, { once: true });
    decline.addEventListener('click', onDecline, { once: true });
    closeBtn.addEventListener('click', onDecline, { once: true });
    overlay.addEventListener('click', onOverlayClick);
    document.addEventListener('keydown', onKeydown);

    overlay._cleanup = function () {
      overlay.removeEventListener('click', onOverlayClick);
      document.removeEventListener('keydown', onKeydown);
    };

    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('upsell-open');
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      accept.focus();
    });
  }

  function closeUpsellModal() {
    if (!upsellEl) return;
    upsellEl.classList.remove('is-open');
    upsellEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('upsell-open');
    if (upsellEl._cleanup) upsellEl._cleanup();
    if (upsellLastFocus && typeof upsellLastFocus.focus === 'function') {
      upsellLastFocus.focus();
    }
  }

  /* -------------------------------------------------------
     4. STICKY CTA BAR
     Pokazuje się po opuszczeniu hero, chowa gdy widoczny
     jest pełny selektor pakietu (żeby nie dublować CTA).
     ------------------------------------------------------- */
  var sticky = document.querySelector('[data-sticky]');
  if (sticky && bundleInputs.length && 'IntersectionObserver' in window) {
    var pastHero = false;
    var selectorVisible = false;

    var update = function () {
      var show = pastHero && !selectorVisible;
      sticky.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky', show);
    };

    // Pozycję liczymy ze scrolla, nie z IntersectionObservera.
    // Observer nie odpala, gdy strona wczyta się od razu w środku
    // (link z kotwicą, przywrócona pozycja scrolla, szybki flick) —
    // sentinel nigdy wtedy nie przechodzi przez ekran.
    var heroSentinel = document.querySelector('[data-hero-end]');
    var ticking = false;
    var measure = function () {
      ticking = false;
      if (heroSentinel) {
        pastHero = heroSentinel.getBoundingClientRect().top < 0;
      } else {
        pastHero = window.scrollY > 400;
      }
      update();
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(measure); }
    }, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    measure();

    var selectors = document.querySelectorAll('[data-bundle-selector]');
    if (selectors.length) {
      var visibleCount = 0;
      var selObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visibleCount++;
          else visibleCount = Math.max(0, visibleCount - 1);
        });
        selectorVisible = visibleCount > 0;
        update();
      }, { threshold: 0.25 });
      selectors.forEach(function (s) { selObserver.observe(s); });
    }
  }

  /* -------------------------------------------------------
     5. KARUZELA „PODGLĄD WNĘTRZA" — kropki
     ------------------------------------------------------- */
  document.querySelectorAll('[data-peek]').forEach(function (track) {
    var dots = track.parentElement.querySelectorAll('[data-peek-dot]');
    var items = track.querySelectorAll('.peek__item');
    if (!dots.length || !items.length) return;

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        items[i].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    var sync = function () {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      items.forEach(function (item, i) {
        var mid = item.offsetLeft + item.offsetWidth / 2;
        var d = Math.abs(mid - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === best ? 'true' : 'false');
      });
    };
    sync();
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
  });

  /* -------------------------------------------------------
     6. ODSŁANIANIE SEKCJI PRZY SCROLLU
     ------------------------------------------------------- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(function (el) { revealObserver.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* -------------------------------------------------------
     7. FAQ — tylko jedna odpowiedź otwarta naraz
     ------------------------------------------------------- */
  var faqItems = document.querySelectorAll('[data-faq] .faq__item');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      faqItems.forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });
})();
